
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { faCircleCheck, faCircleExclamation, faCircleX, IconDefinition } from '@fortawesome/pro-light-svg-icons';


export interface DialogButton {
  label: string;
  type?: 'primary' | 'secondary' | 'danger' | 'custom';
  action: () => void;
}

export interface DialogConfig {
  title: string;
  subtitle?: string;
  icon?: string;
  buttons?: DialogButton[];
}

@Component({
  selector: 'app-dialog-generic',
  templateUrl: './dialog-generic.component.html',
  styleUrls: ['./dialog-generic.component.scss']
})
export class DialogGenericComponent {
  icon!: IconDefinition | null;
  colorClass!: string;
  private iconMap: { [key: string]: IconDefinition } = {
    warning: faCircleExclamation,
    error: faCircleX,
    check: faCircleCheck
  };
  private colorMap: { [key: string]: string } = {
    warning: 'color-warning',
    error: 'color-error',
    check: 'color-check',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogConfig,
    private dialogRef: MatDialogRef<DialogGenericComponent>
  ) {
    this.icon = this.iconMap[data.icon] || null;
    this.colorClass = this.colorMap[data.icon] || 'color-default';
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
